/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import { Typography } from "@mui/material";

import { colors } from "@dotnet/telematics-design-system";

import CreditBehaviourTable from "./CreditBehaviourTable/CreditBehaviourTable";

const BottomHowCreditsWorkDialogContent = () => {
  const { t } = useTranslation();

  return (
    <div
      css={css({
        display: "flex",
        flexDirection: "column",
        gap: "8px"
      })}
    >
      <Typography variant="body1Medium" color={colors.textDark}>
        {t("Dashboard##how credits work##bottom content##header")}
      </Typography>
      <CreditBehaviourTable />
    </div>
  );
};

export default BottomHowCreditsWorkDialogContent;
